export const supportedLanguages = ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'ru', 'zh'];
export const DEFAULT_LANG = 'en';
